function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _require = require('@uppy/core'),
    Plugin = _require.Plugin;

var cuid = require('cuid');

var Translator = require('@uppy/utils/lib/Translator');

var _require2 = require('@uppy/companion-client'),
    Provider = _require2.Provider,
    Socket = _require2.Socket;

var emitSocketProgress = require('@uppy/utils/lib/emitSocketProgress');

var getSocketHost = require('@uppy/utils/lib/getSocketHost');

var settle = require('@uppy/utils/lib/settle');

var limitPromises = require('@uppy/utils/lib/limitPromises');

var _require3 = require("activestorage"),
    DirectUpload = _require3.DirectUpload;

module.exports = /*#__PURE__*/function (_Plugin) {
  _inherits(ActiveStorageUpload, _Plugin);

  var _super = _createSuper(ActiveStorageUpload);

  function ActiveStorageUpload(uppy, opts) {
    var _this;

    _classCallCheck(this, ActiveStorageUpload);

    _this = _super.call(this, uppy, opts);
    _this.id = opts.id || 'ActiveStorageUpload';
    _this.title = opts.title || 'ActiveStorageUpload';
    _this.type = 'uploader';
    var defaultOptions = {
      limit: 0,
      timeout: 30 * 1000,
      directUploadUrl: null
    };
    _this.opts = Object.assign({}, defaultOptions, opts); // Simultaneous upload limiting is shared across all uploads with this plugin.

    if (typeof _this.opts.limit === 'number' && _this.opts.limit !== 0) {
      _this.limitUploads = limitPromises(_this.opts.limit);
    } else {
      _this.limitUploads = function (fn) {
        return fn;
      };
    }

    _this.handleUpload = _this.handleUpload.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ActiveStorageUpload, [{
    key: "install",
    value: function install() {
      this.uppy.addUploader(this.handleUpload);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.removeUploader(this.handleUpload);
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(fileIDs) {
      var _this2 = this;

      if (fileIDs.length === 0) {
        this.uppy.log('[ActiveStorage] No files to upload!');
        return Promise.resolve();
      }

      this.uppy.log('[ActiveStorage] Uploading...');
      var files = fileIDs.map(function (fileID) {
        return _this2.uppy.getFile(fileID);
      });
      return this.uploadFiles(files).then(function () {
        return null;
      });
    }
  }, {
    key: "upload",
    value: function upload(file, current, total) {
      var _this3 = this;

      this.uppy.log("uploading ".concat(current, " of ").concat(total));
      return new Promise(function (resolve, reject) {
        var timer = _this3.createProgressTimeout(_this3.opts.timeout, function (error) {
          xhr.abort();

          _this3.uppy.emit('upload-error', file, error);

          reject(error);
        });

        var directHandlers = {
          directUploadWillStoreFileWithXHR: null,
          directUploadDidProgress: null
        };

        directHandlers.directUploadDidProgress = function (ev) {
          _this3.uppy.log("[XHRUpload] ".concat(id, " progress: ").concat(ev.loaded, " / ").concat(ev.total));

          timer.progress();

          if (ev.lengthComputable) {
            _this3.uppy.emit('upload-progress', file, {
              uploader: _this3,
              bytesUploaded: ev.loaded,
              bytesTotal: ev.total
            });
          }
        };

        directHandlers.directUploadWillStoreFileWithXHR = function (request) {
          request.upload.addEventListener("progress", function (event) {
            return directHandlers.directUploadDidProgress(event);
          });
        };

        var upload = new DirectUpload(file.data, _this3.opts.directUploadUrl, directHandlers);
        var id = cuid();
        upload.create(function (error, blob) {
          _this3.uppy.log("[XHRUpload] ".concat(id, " finished"));

          timer.done();

          if (error) {
            var response = {
              status: 'error'
            };

            _this3.uppy.setFileState(file.id, {
              response: response
            });

            _this3.uppy.emit('upload-error', file, error);

            return reject(error);
          } else {
            var _response = {
              status: 'success',
              directUploadSignedId: blob.signed_id
            };

            _this3.uppy.setFileState(file.id, {
              response: _response
            });

            _this3.uppy.emit('upload-success', file, blob);

            return resolve(file);
          }
        });

        _this3.uppy.on('file-removed', function (removedFile) {
          if (removedFile.id === file.id) {
            timer.done();
            upload.abort();
          }
        });

        _this3.uppy.on('upload-cancel', function (fileID) {
          if (fileID === file.id) {
            timer.done();
            upload.abort();
          }
        });

        _this3.uppy.on('cancel-all', function () {
          timer.done();
          upload.abort();
        });
      });
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this4 = this;

      var actions = files.map(function (file, i) {
        var current = parseInt(i, 10) + 1;
        var total = files.length;

        if (file.error) {
          return function () {
            return Promise.reject(new Error(file.error));
          };
        } else {
          _this4.uppy.emit('upload-started', file);

          return _this4.upload.bind(_this4, file, current, total);
        }
      });
      var promises = actions.map(function (action) {
        var limitedAction = _this4.limitUploads(action);

        return limitedAction();
      });
      return settle(promises);
    } // Helper to abort upload requests if there has not been any progress for `timeout` ms.
    // Create an instance using `timer = createProgressTimeout(10000, onTimeout)`
    // Call `timer.progress()` to signal that there has been progress of any kind.
    // Call `timer.done()` when the upload has completed.

  }, {
    key: "createProgressTimeout",
    value: function createProgressTimeout(timeout, timeoutHandler) {
      var uppy = this.uppy;
      var self = this;
      var isDone = false;

      function onTimedOut() {
        uppy.log("[XHRUpload] timed out");
        var error = new Error(self.i18n('timedOut', {
          seconds: Math.ceil(timeout / 1000)
        }));
        timeoutHandler(error);
      }

      var aliveTimer = null;

      function progress() {
        // Some browsers fire another progress event when the upload is
        // cancelled, so we have to ignore progress after the timer was
        // told to stop.
        if (isDone) return;

        if (timeout > 0) {
          if (aliveTimer) clearTimeout(aliveTimer);
          aliveTimer = setTimeout(onTimedOut, timeout);
        }
      }

      function done() {
        uppy.log("[XHRUpload] timer done");

        if (aliveTimer) {
          clearTimeout(aliveTimer);
          aliveTimer = null;
        }

        isDone = true;
      }

      return {
        progress: progress,
        done: done
      };
    }
  }]);

  return ActiveStorageUpload;
}(Plugin);